import { useState } from "react";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useMST4050_R01Store } from "./Store_MST4050_R01";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { SearchMonthSingleForm } from "src/components/common/form/search/SearchMonthSingleForm";
import { formatDateMonth, formatDateYear4 } from "src/utils/string/stringUtil";

// 조회월·상태·약품유형 검색조건을 입력하는 영역을 렌더링한다.
export const SearchSection_MST4050_R01 = () => {

	// 공통코드 옵션과 현재 조회조건을 연결해 검색 필터를 구성한다.
	const { eqmStatusList, chemicalTypeList } = useCommonCodeStore();
	const { MST4050_R01Filter, setMST4050_R01Filter } = useMST4050_R01Store();
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });

	return (
		<SearchSectionForm>
			<SearchMonthSingleForm
				label="등록일자"
				visible={pickerVisible}
				setVisible={setPickerVisible}
				value={new Date(`${MST4050_R01Filter.searchYm}-01`)}
				onChange={(date) => date && setMST4050_R01Filter({
					searchYm: `${formatDateYear4(date)}-${formatDateMonth(date)}`
				})}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
			<SearchDropDownForm
				label="상태"
				value={MST4050_R01Filter.eqmStatus || ''}
				onChangeItem={(item) => setMST4050_R01Filter({ eqmStatus: item?.minorCd || '' })}
				optionList={eqmStatusList}
			/>
			<SearchDropDownForm
				label="약품유형"
				value={MST4050_R01Filter.equipmentType || ''}
				onChangeItem={(item) => setMST4050_R01Filter({ equipmentType: item?.minorCd || '' })}
				optionList={chemicalTypeList}
			/>
		</SearchSectionForm>
	);
};
